import React from 'react';

import TextValue from 'ui-library/TextValue';
import * as DateUtil from 'util/DateUtil';
import {Optional} from 'util/Types';

import TableCellWithTooltip, {NO_VALUE_TOOLTIP_TITLE} from './TableCellWithTooltip';

interface DateTableCellProps {
  className?: string;
  date: Optional<string>;
}

export default function DateTableCell({className, date}: DateTableCellProps): JSX.Element {
  return (
    <TableCellWithTooltip
      className={className}
      tooltipTitle={date ? DateUtil.readableTime(date, {showTime: false}) : NO_VALUE_TOOLTIP_TITLE}
    >
      <TextValue value={date && DateUtil.readableTime(date, {showTime: false})} />
    </TableCellWithTooltip>
  );
}
